import { render, staticRenderFns } from "./BookingsConfirm.vue?vue&type=template&id=d33d21f6&"
import script from "./BookingsConfirm.vue?vue&type=script&lang=js&"
export * from "./BookingsConfirm.vue?vue&type=script&lang=js&"
import style0 from "./BookingsConfirm.vue?vue&type=style&index=0&id=d33d21f6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports